import { render, staticRenderFns } from "./ParallelGatewayProps.vue?vue&type=template&id=23df13e1"
import script from "./ParallelGatewayProps.vue?vue&type=script&lang=js"
export * from "./ParallelGatewayProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports